import * as React from "react";
import { cn } from "@/app/utils/tw-merge";

export function FilterChips<T extends string>({
  options,
  value,
  onChange,
  className,
}: {
  options: { value: T; label: string }[];
  value: T | "";
  onChange: (v: T | "") => void;
  className?: string;
}) {
  return (
    <div className={cn("inline-flex rounded-md border border-border bg-card p-0.5", className)}>
      {options.map((o) => {
        const active = value === o.value;
        return (
          <button
            key={o.value || "_all"}
            type="button"
            onClick={() => onChange(o.value)}
            className={cn(
              "h-7 px-3 text-xs rounded-sm font-medium transition-colors",
              active
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
